/**
 * Store Locator Form Modal
 * - Auto-opens after 3 seconds
 * - Opens on .expert-btn click (dynamic)
 * - Closes on × or Escape
 * - Inline-style based (no CSS dependency)
 * - Shopify section safe
 */

(function () {
  'use strict';

  let scrollPosition = 0;
  let modal = null;
  let closeBtn = null;
  let form = null;
  let successMsg = null;
  let errorMsg = null;

  let leadContext = {
  source: 'auto_popup',   // default
  store_name: null,
  page_url: window.location.href,
  timestamp: null
};

  /* ------------------------------
     Modal open / close
  ------------------------------ */

  function openModal() {
    if (!modal) return;

    scrollPosition = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';

    modal.style.display = 'flex';
  }

  function closeModal() {
    if (!modal) return;

    modal.style.display = 'none';

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);

    if (form) form.reset();
    if (successMsg) successMsg.style.display = 'none';
    if (errorMsg) errorMsg.style.display = 'none';

    leadContext.source = 'auto_popup';
leadContext.store_name = null;
leadContext.timestamp = null;
  }

  /* ------------------------------
     Input restrictions
  ------------------------------ */

  function setupInputValidation() {
    const pincode = document.getElementById('expertPincode');
    const phone = document.getElementById('expertPhone');

    if (pincode) {
      pincode.addEventListener('input', () => {
        pincode.value = pincode.value.replace(/\D/g, '').slice(0, 6);
      });
    }

    if (phone) {
      phone.addEventListener('input', () => {
        phone.value = phone.value.replace(/\D/g, '').slice(0, 10);
      });
    }
  }

  /* ------------------------------
     Form submit (frontend only)
  ------------------------------ */

  function setupFormSubmit() {
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const name = document.getElementById('expertName')?.value.trim();
      const pincode = document.getElementById('expertPincode')?.value.trim();
      const phone = document.getElementById('expertPhone')?.value.trim();

leadContext.timestamp = new Date().toISOString();

const fullName = name.trim();
const nameParts = fullName.split(' ');

const FirstName = nameParts.shift() || '';
const LastName = nameParts.join(' ') || '';

const payload = [
  { Attribute: 'FirstName', Value: FirstName },
  { Attribute: 'Phone', Value: phone },
  // Optional but useful
  { Attribute: 'LastName', Value: LastName || '' },
  { Attribute: 'mx_Zip', Value: pincode || '' },
  { Attribute: 'mx_Store_Name', Value: leadContext.store_name || '' },
  { Attribute: 'mx_Product_Category', Value: window.selectedProductTitle || '' },
  { Attribute: 'Source', Value: 'Store Page' },
  { Attribute: 'mx_Page_URL', Value: leadContext.page_url },
  { Attribute: 'mx_Timestamp', Value: leadContext.timestamp }
];

// console.log('LEAD PAYLOAD:', payload);
  const isValid =
  FirstName.length > 0 &&
  /^\d{10}$/.test(phone);

      if (!isValid) {
        if (errorMsg) errorMsg.style.display = 'block';
        if (successMsg) successMsg.style.display = 'none';
        return;
      }

sendToLeadSquared(payload);
function sendToLeadSquared(payload) {
  fetch(
    'https://api-in21.leadsquared.com/v2/LeadManagement.svc/Lead.Capture?accessKey=u$rb8e71beafdf36138691a09ec61966409&secretKey=292a3a45b837b996f00400cff35c420112d52f37',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
  )
  .then(res => res.json())
  .then(data => {
  // console.log('LeadSquared OK:', data);
  if (successMsg) successMsg.style.display = 'block';
  if (errorMsg) errorMsg.style.display = 'none';
  setTimeout(closeModal, 3000);
})
.catch(err => {
  console.error('LeadSquared ERROR:', err);
  if (errorMsg) errorMsg.style.display = 'block';
});
}

      if (successMsg) successMsg.style.display = 'block';
      if (errorMsg) errorMsg.style.display = 'none';

      // frontend-only
      // console.log('Expert Request:', { name, pincode, phone });

      setTimeout(closeModal, 3000);
    });
  }

  /* ------------------------------
     Init (runs ONLY when modal exists)
  ------------------------------ */

  function init() {
    closeBtn = document.querySelector('.expert-close');
    form = document.getElementById('expertForm');
    successMsg = document.querySelector('.expert-success');
    errorMsg = document.querySelector('.expert-error');

    setupInputValidation();
    setupFormSubmit();

    // Click: Get Assistance (dynamic buttons)
    document.addEventListener('click', function (e) {
  const btn = e.target.closest('.expert-btn');
  if (!btn) return;

  e.preventDefault();

  leadContext.source = 'store_card_click';
  leadContext.store_name = btn.getAttribute('data-store-name') || null;

  openModal();
});

    // Close icon
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    }

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal?.style.display === 'flex') {
        closeModal();
      }
    });

    // Auto-open after 3s
    setTimeout(() => {
  leadContext.source = 'auto_popup';
  leadContext.store_name = null;
  openModal();
}, 4000);
  }

  /* ------------------------------
     Shopify-safe wait loop
  ------------------------------ */

  function waitForModal(retries = 25) {
    modal = document.getElementById('expertModal');

    if (modal) {
      init();
      return;
    }

    if (retries > 0) {
      setTimeout(() => waitForModal(retries - 1), 300);
    }
  }

  /* ------------------------------
     Bootstrap
  ------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForModal());
  } else {
    waitForModal();
  }

})();
